import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const SECTIONS = [
  {
    title: 'Shipping Rates',
    body: 'To keep checkout simple and predictable, we offer flat-rate shipping worldwide, regardless of the size or number of items in your order:',
    items: ['Domestic shipping (UK): £35.00', 'International shipping: £95.00'],
  },
  {
    title: 'Dispatch & Delivery Times',
    items: [
      'Prints: dispatched within 2–5 business days.',
      'Original paintings: dispatched within 5–7 business days, as they require specialised protective packaging and custom boxing.',
      'Tracking details are emailed to you as soon as your artwork is handed over to the courier.',
    ],
  },
  {
    title: 'Packaging & Protection',
    body: 'Every artwork is packed to professional museum standards:',
    items: [
      'Prints are carefully rolled in heavy-duty, crush-resistant mailing tubes or shipped flat in rigid, reinforced mailers.',
      'Paintings are wrapped in protective archival glassine, surrounded by thick layers of bubble wrap, fitted with corner protectors and shipped in double-walled corrugated boxes.',
    ],
  },
  {
    title: 'Import Duties, Customs & Local Taxes',
    body: 'For shipments outside the UK, the buyer is responsible for any import duties, customs fees or VAT levied by the destination country on arrival. Customs policies vary widely, so please check with your local customs office before purchasing.',
  },
  {
    title: 'Damages & Insurance',
    body: 'Your artwork is fully insured in transit. In the rare event that your package arrives damaged, please photograph both the outer packaging and the artwork immediately and contact us within 48 hours of delivery at info@zebraonegallery.com — we will arrange a replacement or full refund.',
  },
];

const ShippingPage = () => (
  <div className="min-h-screen bg-white" data-testid="shipping-page">
    <SEO
      title="Shipping & Delivery — Zebra One Gallery"
      description="Flat-rate, fully tracked and insured shipping: UK £35, international £95. Dispatch times, museum-standard packaging, customs and insurance."
    />
    <Header />
    <main className="max-w-3xl mx-auto px-6 py-24 sm:py-32">
      <div className="text-xs tracking-[0.3em] uppercase text-neutral-400 mb-3">Buyers' Information</div>
      <h1 className="font-serif text-4xl sm:text-5xl text-neutral-900 mb-6 leading-tight" data-testid="shipping-h1">
        Shipping &amp; Delivery
      </h1>
      <p className="text-neutral-700 leading-relaxed mb-10">
        We want your new artwork to arrive safely and in perfect condition. We ship original paintings and
        high-quality prints worldwide using trusted, fully tracked art couriers and postal services.
      </p>
      {SECTIONS.map((s) => (
        <section key={s.title} className="mb-10" data-testid={`shipping-section-${s.title.split(' ')[0].toLowerCase()}`}>
          <h2 className="text-lg font-medium text-black mb-3">{s.title}</h2>
          {s.body && <p className="text-neutral-700 leading-relaxed mb-3">{s.body}</p>}
          {s.items && (
            <ul className="list-disc pl-5 text-neutral-700 leading-relaxed space-y-2">
              {s.items.map((i) => <li key={i}>{i}</li>)}
            </ul>
          )}
        </section>
      ))}
    </main>
    <Footer />
  </div>
);

export default ShippingPage;
